import {createTheme, DEFAULT_PALETTE, invertPalette} from '@bsky.app/alf'

/**
 * Cyberdione's shared brand tokens, adapted to ALF's semantic ramps.
 * Source: ui-kit/src/theme/brandTheme.ts and www-cyberdione-ai/src/theme.ts.
 * Keep raw white/black for media overlays; app surfaces use contrast tokens.
 */
const lightBrandPalette = {
  ...DEFAULT_PALETTE,
  contrast_0: '#E6D5BC',
  contrast_25: '#F2E7D5',
  contrast_50: '#D4C3AC',
  contrast_100: '#C4B39D',
  contrast_200: '#B3A895',
  contrast_300: '#8A7F6E',
  contrast_400: '#5F5A4F',
  contrast_500: '#5F5A4F',
  contrast_600: '#463F38',
  contrast_700: '#5F5A4F',
  contrast_800: '#332E28',
  contrast_900: '#231F1B',
  contrast_950: '#231F1B',
  contrast_975: '#161311',
  contrast_1000: '#332E28',
  primary_25: '#FBF6EE',
  primary_50: '#FFE4C8',
  primary_100: '#FFD4B0',
  primary_200: '#FFC498',
  primary_300: '#FFB480',
  primary_400: '#FF8B3E',
  // The shared strong accent keeps small links legible on the sand surface.
  primary_500: '#993A15',
  primary_600: '#662810',
  primary_700: '#993A15',
  primary_800: '#662810',
  primary_900: '#662810',
  primary_950: '#662810',
  primary_975: '#662810',
}

const darkBrandPalette = {
  ...invertPalette(DEFAULT_PALETTE),
  contrast_0: '#161311',
  contrast_25: '#26221E',
  contrast_50: '#38322C',
  contrast_100: '#38322C',
  contrast_200: '#4F4740',
  contrast_300: '#877F70',
  contrast_400: '#B3A895',
  contrast_500: '#B3A895',
  contrast_600: '#B3A895',
  contrast_700: '#B3A895',
  contrast_800: '#DFD0BA',
  contrast_900: '#FFE4C8',
  contrast_950: '#FFE4C8',
  contrast_975: '#FFF6EA',
  contrast_1000: '#DFD0BA',
  primary_25: '#231F1B',
  primary_50: '#332E28',
  primary_100: '#662810',
  primary_200: '#993A15',
  primary_300: '#CC4E1B',
  primary_400: '#FF6B35',
  primary_500: '#FF8B3E',
  primary_600: '#FFA668',
  primary_700: '#FFB480',
  primary_800: '#FFC498',
  primary_900: '#FFD4B0',
  primary_950: '#FFE4C8',
  primary_975: '#FFF6EA',
}

const DEFAULT_THEMES = {
  light: createTheme({
    scheme: 'light',
    name: 'light',
    palette: lightBrandPalette,
  }),
  dark: createTheme({scheme: 'dark', name: 'dark', palette: darkBrandPalette}),
  dim: createTheme({
    scheme: 'dark',
    name: 'dim',
    palette: {
      ...darkBrandPalette,
      contrast_0: '#26221E',
      contrast_25: '#38322C',
    },
  }),
}

DEFAULT_THEMES.dark.atoms.text_link.color = darkBrandPalette.primary_500
DEFAULT_THEMES.dim.atoms.text_link.color = darkBrandPalette.primary_500

export const themes = {
  lightPalette: DEFAULT_THEMES.light.palette,
  darkPalette: DEFAULT_THEMES.dark.palette,
  dimPalette: DEFAULT_THEMES.dim.palette,
  light: DEFAULT_THEMES.light,
  dark: DEFAULT_THEMES.dark,
  dim: DEFAULT_THEMES.dim,
}

/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const lightPalette = DEFAULT_THEMES.light.palette
/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const darkPalette = DEFAULT_THEMES.dark.palette
/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const dimPalette = DEFAULT_THEMES.dim.palette
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const light = DEFAULT_THEMES.light
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const dark = DEFAULT_THEMES.dark
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const dim = DEFAULT_THEMES.dim
